var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-card-title',[(_vm.tile.default_icon)?_c('v-icon',{attrs:{"left":""},domProps:{"textContent":_vm._s(_vm.tile.default_icon)}}):_vm._e(),_vm._v(" "+_vm._s(_vm.tile.name)+" ")],1),_c('v-card-text',[_c('recursive-documents',{attrs:{"items":_vm.tile.contentable}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }